import { Injectable } from "@angular/core";

@Injectable()
export class dataService {
  name: any;
  constructor() {}
}
